import { registerRootComponent } from "expo";
import AppWrapper from "./src/App";

registerRootComponent(AppWrapper);
